define('models/reseller_personal',['require','backbone','models/phone_number','models/reseller_role'],function(require){

    var Backbone = require('backbone');

    var PhoneNumberModel = require('models/phone_number');
    var RoleModel = require('models/reseller_role');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'reseller-managers/' + this.id + '/' ) :
                ( App.Config.apiBase + 'reseller-managers/' );
        },

        defaults: function () {
            return {
                id:null,
                first_name: '',
                last_name: '',
                email: '',
                phone_number: new PhoneNumberModel().attributes,
                phone_country: 0,
                phone_value: '',
                role:0,
                role_object: new RoleModel().attributes,
            };
        }
    });
});
